import { type ReactNode, createContext, useContext } from 'react'

type BusinessContextValue = {
  readonly isBusiness: boolean
}

// For residential no provider needed, value defaults to false
const BusinessContext = createContext<BusinessContextValue>({
  isBusiness: false
})

export const BusinessProvider = ({
  children,
  isBusiness
}: {
  readonly children: ReactNode
  readonly isBusiness: boolean
}) => {
  return (
    <BusinessContext.Provider value={{ isBusiness }}>
      {children}
    </BusinessContext.Provider>
  )
}

export const useBusiness = () => useContext(BusinessContext)
